import React, { Component } from 'react';
import {  Button , Confirm , Container , Dimmer , Grid , Header , Icon ,Input , Loader , Modal , Popup , Table , Pagination } from 'semantic-ui-react'; 
import * as constantes from '../../constantes';

import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { DatePicketControl } from '../controls/Controles'; 

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

registerLocale('es', es)

const style = {
  h1: {
    marginTop: '1em',
  },
  h2: {
    margin: '1em 0em 1em',
  },
  h3: {
    marginTop: '2em',
    padding: '2em 0em',
  },
  last: {
    marginBottom: '300px',
  },
}

export default class Feriados extends Component{

  constructor(props) {
      super(props);
      this.state = {
          isLoaded: false,
          error: null,
          errors: [],
          listaFeriados: [],          
          showModalEdit:false,
          openConfirmDuplicar : false,
          activePage:1,
          totalPages:0,
          totalRows:0,
          begin: 0,
          end: 5 , 

          nuevoFecha : new Date(),
          nuevoDescripcion : '',

          confirmEliminarFeriadoOpen : false , 
          feriadoDelete : null ,
          dimmerFeriados : false 
      };

      this.onChange = this.onChange.bind(this);
      this.nuevoFeriado = this.nuevoFeriado.bind(this);
      this.setShowModalEdit =this.setShowModalEdit.bind(this) ;
      
      this.duplicarFeriados =this.duplicarFeriados.bind(this) ;
      this._handlerChangeFechaFunction =this._handlerChangeFechaFunction.bind(this) ;
      this._handlerChangeTextFunction =this._handlerChangeTextFunction.bind(this) ;
      
      this.eliminarFeriado =this.eliminarFeriado.bind(this);
      
  }

    componentDidMount() {
        auth0Client.isExpired();
        this.cargarListaDeFeriadosPaginado( 1 );
    }

    _handlerChangeFechaFunction( date , name ){
        let METHODNAME = '_handlerChangeFechaFunction - ';
        console.log(METHODNAME + 'name = ' + name + ', value='+ date );
        this.setState({
            [name]: date
        });
    }

    _handlerChangeTextFunction( e ){
        let METHODNAME = '_handlerChangeTextFunction - ';

        let valor = e.target.value;
        let name = e.target.name;
        //console.log(METHODNAME + 'name = ' + name + ', value='+ valor );
        this.setState({
            [name]: valor
        });

    }

    onChange (e, pageInfo) {
      let METHODNAME = 'onChange - ';
      console.log(METHODNAME + 'INI');

      console.log(METHODNAME + 'activePage = ' + pageInfo.activePage );

      this.setState({
          activePage : pageInfo.activePage
      });

      this.cargarListaDeFeriadosPaginado( pageInfo.activePage );

    };
   
    async cargarListaDeFeriadosPaginado( paginaActiva ){
        let METHODNAME = 'cargarListaDeFeriadosPaginado - ';
        
        let url = server+`/feriados`;
        
        let _rows = 14;
        let _begin = 0 ;
        let _end = _rows - 1;

        if( paginaActiva > 1 ){
            _begin = paginaActiva * _rows ;
            _end = _rows - 1; 
        }

        let dataForm = null;
        dataForm = {
            pagina : paginaActiva-1,
            filas : _rows
        }

        fetch( 
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                console.log(METHODNAME + 'RESULTADO DE LISTA DE FERIADOS');
                
                this.setState({
                    isLoaded: true,
                    listaFeriados: result.listaFeriados,
                    totalRows: result.cantidadRegistros,
                    activePage : paginaActiva, 
                    totalPages: result.totalPaginas,
                    begin: _begin,
                    end: _end
                });

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        ) 
    }

    async duplicarFeriados(){
        let METHODNAME = 'duplicarFeriados - ';
        console.log(METHODNAME + 'INI.' );
        
        let url =  `${server}/feriados/duplicar/`;

        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        }) 
        .then(res => res.json())
        .then( 
            (result) => {
                
                console.log(METHODNAME +  'RESULTADO OBTENIDO') ;

                if( result.resultado === 'true'){
                    console.warn(METHODNAME +  'grabado correctamente' );
                    this.cargarListaDeFeriadosPaginado(1);
                    this.setState({
                        openConfirmDuplicar : false
                    });
                }else{
                    console.warn(METHODNAME +  'ocurrio un error al procesar el resultado' );
                }
                
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        ) 
      
    }

  nuevoFeriado(){
    let METHODNAME = 'nuevoFeriado - ';
    console.log(METHODNAME + 'INI.' );

    this.setState({
        nuevoFecha : new Date(),
        nuevoDescripcion : ''
    });

    this.setShowModalEdit( true )

  }

  registrarFeriado(){
    let METHODNAME = 'registrarFeriado - ';
    console.log(METHODNAME + 'INI');

    //Llamada REST 
    let dataForm = {
        feriadoFecha : this.state.nuevoFecha ,
        feriadoDescripcion : this.state.nuevoDescripcion 
    }

    let url =  `${server}/feriados/`;

    fetch( 
        url , {
        method: 'POST',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
        },
        body:JSON.stringify(dataForm)
    }) 
    .then(res => res.json())
    .then( 
        (result) => {

            if( result.resultado === 'true'){
                console.warn(METHODNAME +  'grabado correctamente');
                
                this.cargarListaDeFeriadosPaginado(1);

                this.setState({
                    showModalEdit : false
                });

            }else{
                console.lopg('Ha ocurrido un error al procesar la repsuesta del servicio. ' );
                console.lopg('Detalle: ' + result.error );
            }

        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            console.log(METHODNAME + 'error = ' + error );
            this.setState({
                isLoaded: true,
                error
            });
        }
    )

  }

  consultaEliminarFeriado(feriado){
    let METHODNAME = 'consultaEliminarFeriado - ';
    console.log(METHODNAME + 'INI');

    this.setState({
        confirmEliminarFeriadoOpen : true , 
        feriadoDelete : feriado ,
        dimmerFeriados :  false 
    });

  }
  
  async eliminarFeriado(){
    let METHODNAME = 'eliminarFeriado - ';
    console.log(METHODNAME + 'INI');
    
    this.setState({
        dimmerFeriados : true ,
        confirmEliminarFeriadoOpen : false , 
        error2 : '' 
    });

    let url = `${server}/feriados/`;
    let dataForm = {
        authUsername : localStorage.getItem('usuario'),
        feriadoFecha : this.state.feriadoDelete
    }

    const json = await fetch( url , {
        method: 'DELETE',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
        },
        body:JSON.stringify(dataForm)
    }).then((result) => {
        console.log(METHODNAME + 'RESPUESTA OBTENIDA');
        result.json().then((resp) => {

            if( resp.resultado === 'true' ){
                console.warn(METHODNAME +  'eliminado correctamente.' );

                //VER FERIADOS 
                this.setState({
                    dimmerFeriados : false , 
                    error2 : '' 
                });
                this.cargarListaDeFeriadosPaginado( 1 );

            }else{
                console.warn(METHODNAME +  'No se pudo eliminar ' );
                console.warn(METHODNAME +  'error : ' + resp.error );
                this.setState({ 
                    dimmerFeriados : false , 
                    error2 : resp.error 
                }); 
            }

        }).catch((error) => { 
            console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
            this.setState({ 
                dimmerFeriados : false , 
                error2 : error 
            }); 
        });

    }).catch((error) => { 
        console.error(METHODNAME +  'Server Error: ' + error)
        this.setState({ 
            dimmerFeriados : false , 
            error2 : error 
        }); 
    });

    return json;
  }

  setShowModalEdit( mostrar ){
    this.setState({
        showModalEdit: mostrar
    });
  }

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }

  handleDetail( pregunta ){
    let METHODNAME = 'handleDetail - ';
    console.log(METHODNAME + 'INI');

    console.log(METHODNAME + 'Preguntra Id = ' + pregunta.idPregunta );

    console.log(METHODNAME + 'FIN');
  } 

  render() {

    const { error, isLoaded, listaFeriados , activePage , totalPages } = this.state;

    if (error) {
        return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Loading...</div>;
    } else {

            return(
                <div>
                <Container>

                <Header as='h2' content='Lista de Feriados' style={style.h1} textAlign='center' />

                <div>
 
                    <Button onClick={ () => this.handleChangeBoolean('openConfirmDuplicar', true ) }
                            color='green' size='tiny' >
                        <Icon name="clone" />
                        Duplicar Feriados</Button>

                    <Button onClick={ () => this.nuevoFeriado()}
                            color='green' size='tiny' >
                        <Icon name="add circle" />
                        Agregar Feriado</Button>
                 
                </div>
            
                <Table celled>
                    <Table.Header>
                        <Table.Row key='head0001'>
                            <Table.HeaderCell>Fecha</Table.HeaderCell> 
                            <Table.HeaderCell>Descripcion</Table.HeaderCell>
                            <Table.HeaderCell>Estado</Table.HeaderCell>
                            <Table.HeaderCell>Acciones</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
            
                    <Table.Body>
                        
                        { listaFeriados && listaFeriados.map(feriado => (
                            <Table.Row key={feriado.fecha}>
                                <Table.Cell>{feriado.fecha}</Table.Cell> 
                                <Table.Cell>{feriado.descripcion}</Table.Cell>
                                <Table.Cell>{feriado.estado === 1 ? 'Activo' : 'Inactivo'}</Table.Cell> 
                                <Table.Cell>
                                    {feriado.estado === 1 ? 
                                    <Button color='red' animated="vertical"  size='mini'
                                            onClick={ () => this.consultaEliminarFeriado(feriado.fecha)}  >
                                        <Button.Content visible>
                                            <Icon name="trash alternate outline" />
                                        </Button.Content>
                                        <Button.Content hidden>
                                            Eliminar
                                        </Button.Content>
                                    </Button>
                                    : 
                                    ''}
                                </Table.Cell> 
                            </Table.Row>
                        ))}

                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='3' textAlign='center'>
                                <Pagination key='pag0001'
                                    activePage={activePage} 
                                    onPageChange={this.onChange}
                                    totalPages={totalPages} />

                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
            
                </Table>
                               
                </Container>
                
                <Dimmer active={this.state.dimmerFeriados} inverted >
                    <Loader>Loading</Loader>
                </Dimmer>

                <Confirm
                    open={this.state.openConfirmDuplicar}
                    header='Duplicar feriados'
                    content='Se van a tomar todos los feriados del último año y se registrarán para el siguiente año. ¿Está seguro de realizar esta acción?'
                    onCancel={ () => this.handleChangeBoolean('openConfirmDuplicar', false )} 
                    onConfirm={this.duplicarFeriados}
                />

                <Confirm
                    open={this.state.confirmEliminarFeriadoOpen}
                    header='Eliminar Feriado'
                    content='¿Está seguro que desea eliminar el registro seleccionado?'
                    onCancel={ () => this.handleChangeBoolean('confirmEliminarFeriadoOpen', false )} 
                    onConfirm={this.eliminarFeriado}
                />

            <Modal
                closeIcon
                closeOnEscape={false}
                onClose={() => this.setShowModalEdit(false)} 
                open={this.state.showModalEdit}
            >
            <Modal.Header>Agregar Feriado</Modal.Header>
            <Modal.Content>
                 
                <Modal.Description>
                    <Grid columns={2} >
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Fecha:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Fecha del feriado'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <DatePicketControl
                                    id='nuevoFechaID'
                                    name='nuevoFecha'
                                    changeHandler = {this._handlerChangeFechaFunction}
                                    valor={this.state.nuevoFecha}
                                />

                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                Descripción:
                                <Popup
                                    trigger={<Icon circular name='question circle' />}
                                    content='Descripción del feriado'
                                    inverted
                                    />
                            </Grid.Column>
                            <Grid.Column>
                                <Input placeholder='Descripción feriado' 
                                    name='nuevoDescripcion'
                                    value={this.state.nuevoDescripcion} 
                                    onChange = {this._handlerChangeTextFunction}/>
                            </Grid.Column>
                        </Grid.Row> 
                    </Grid>
                </Modal.Description>

            </Modal.Content>
            <Modal.Actions>
                <Button color='blue' onClick={() => this.setShowModalEdit(false)}>
                    Cancelar
                </Button>
                <Button
                    content="Regsitrar"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => this.registrarFeriado()}
                    color='red'
                />
            </Modal.Actions>
            </Modal>
            </div>
            );

        }
  }

}